import "./GymCoachComponent.scss";
import CoachVector from "images/CoachVector.svg";
import PassVeryHeavy from "images/PassVeryHeavy.svg";

interface IGymCoachComponent {
  image: string;
  alt: string;
  description: string;
  phoneNumber: string;
  isDefaultCoach?: boolean;
  hasInfo?: boolean;
  female?: boolean;
  onInfoClick?: () => void;
}

const GymCoachComponent = ({
  image,
  alt,
  description,
  phoneNumber,
  isDefaultCoach,
  hasInfo,
  female,
  onInfoClick,
}: IGymCoachComponent) => {
  return (
    <section>
      <div className="gymCoachComponentWrapper">
        <img src={image} alt={alt} loading="lazy" className="gymCoachImage" />
        <div className="descriptionComponent">
          <span className="descriptionTitle">
            {female ? "Trenerka" : "Trener"}:{" "}
          </span>
          {description}
        </div>
        {phoneNumber && phoneNumber !== "-" && (
          <a href={`tel:${phoneNumber}`} className="phoneNumberComponent">
            {phoneNumber}
          </a>
        )}
        {hasInfo && (
          <button
            className="gymCoachInfoBadge"
            onClick={onInfoClick}
            aria-label="Więcej informacji o trenerze">
            ℹ
          </button>
        )}
        {isDefaultCoach && (
          <img
            className="defaultCoachIcon"
            src={PassVeryHeavy}
            alt={`Default Coach icon`}
          />
        )}
      </div>
      <img
        className="coachVector"
        src={CoachVector}
        alt="Bottom Coach Component Vector"
      />
    </section>
  );
};

export default GymCoachComponent;
